// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"ConfirmationDialog_modalWrap__I_Fpg","modalButtons":"ConfirmationDialog_modalButtons__H6Vdm"};